import React from "react";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import { hasPermission, privilegesEnum } from "../../helpers/PermissionHelper";
import styles from "./ActionButtons.module.scss";

interface ActionButtonsProps {
  onSave: () => void;
  onCancel: () => void;
  loading?: boolean;
  disabled?: boolean;
  saveText?: string;
  cancelText?: string;
  permission?: keyof typeof privilegesEnum;
  show?: boolean;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onSave,
  onCancel,
  loading = false,
  disabled = false,
  saveText,
  cancelText,
  permission = privilegesEnum.WRITE_CLIENTS,
  show = true,
}) => {
  const { t } = useTranslation();

  if (!show || !hasPermission(permission)) {
    return null;
  }

  return (
    <div className={styles.actionButtonsWrapper}>
      <Button
        onClick={onSave}
        className={styles.saveButton}
        type="primary"
        loading={loading}
        disabled={disabled || loading}
      >
        {loading ? t("Common-Saving") : (saveText || t("Common-Save"))}
      </Button>
      <Button
        onClick={onCancel}
        className={styles.cancelButton}
        type="primary"
        disabled={loading}
      >
        {cancelText || t("Common-Cancel")}
      </Button>
    </div>
  );
};

export default ActionButtons;
